import { SvcTestRepeatabilitySummary, TestResults } from "../../PulmonaryFunctionTests/Shared/PFTAPITypes";
import { ParameterTypeName } from "./ParameterTypes";

export function MapSvcTestAcceptabilitySummaries(testResults: TestResults[]): Array<SvcTestRepeatabilitySummary> {
    return testResults.map(tr => {
        return {
            TestId: tr.TestId,
            Accepted: tr.OverreaderAcceptability,
            Vc: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_VC).Value,
            Ic: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_IC).Value,
        } as SvcTestRepeatabilitySummary;
    })
}
